"use client";

import { useRewrittenHtml } from "./useRewrittenHtml";

interface RichTextProps {
  data: {
    body: string;
  };
}

export default function RichText({ data }: RichTextProps) {
    const renderVideo = (html: string) => {
      return html.replace(
          /<oembed url="(https:\/\/(?:www\.)?(?:youtube|vimeo)\.com\/[^\"]+)"><\/oembed>/g,
          (match, url) => {
            const videoId = extractVideoId(url);
            const platform = getVideoPlatform(url);
            if (platform === 'vimeo') {
              return `<div class="video-wrapper"><iframe src="https://player.vimeo.com/video/${videoId}" loading="lazy" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`;
            } else if (platform === 'youtube') {
              return `<div class="video-wrapper"><iframe src="https://www.youtube.com/embed/${videoId}" loading="lazy" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
            }
            return match;
          }
      );
    };

    const extractVideoId = (url: string) => {
      const youtubeMatch = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);

      if (youtubeMatch) {
        return youtubeMatch[1];
      }

      const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);

      if (vimeoMatch) {
        return vimeoMatch[1];
      }

      return null;
    };

    const getVideoPlatform = (url: string) => {
      if (url.includes('youtube')) {
        return 'youtube';
      } else if (url.includes('vimeo')) {
        return 'vimeo';
      }
      return '';
    };

    const parsedContent = useRewrittenHtml(renderVideo(data.body));

    return <div className="rich-text" dangerouslySetInnerHTML={{__html: parsedContent}}/>;
}